import {Card, Row, Col} from 'react-bootstrap';
import {connect} from 'react-redux';
import Radio from 'components/shared/StandaloneRadio';
import BaseFeature from './BaseFeature';
import {MLS_MULTI_LUM} from '../../../../../../utils/constantFeatures';
import PropertyPicker from './components/PropertyPicker';
import PropertyDropdown from './components/PropertyDropdown';

class MultiLumSettings extends BaseFeature {

    constructor(props) {
        super(props);
        this.state = {
            numberOfPresets: +props.properties[MLS_MULTI_LUM.numberOfPresets].value,
            activePresetIndex: +props.properties[MLS_MULTI_LUM.activePresetIndex].value,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
    }

    handleChange(propertyName, value) {
        this.props.handleChange(propertyName, value);

        if (propertyName === MLS_MULTI_LUM.numberOfPresets) {
            this.setState({
                numberOfPresets: +value
            });
            this.handleRadioChange(value)
        }
    }

    handleRadioChange(index) {
        this.props.handleChange(MLS_MULTI_LUM.activePresetIndex, String(index));
        this.setState({activePresetIndex: index});
    }

    componentDidUpdate(prevProps) {
        const prevNum = prevProps.properties[MLS_MULTI_LUM.numberOfPresets].value;
        const nextNum = this.props.properties[MLS_MULTI_LUM.numberOfPresets].value;
        const prevIdx = prevProps.properties[MLS_MULTI_LUM.activePresetIndex].value;
        const nextIdx = this.props.properties[MLS_MULTI_LUM.activePresetIndex].value;

        if (prevNum !== nextNum || prevIdx !== nextIdx) {
            this.setState({
                numberOfPresets: +nextNum,
                activePresetIndex: +nextIdx,
            });
        }
    }

    getNumberOfPresetsOptions(property) {
        const min = +property.valueMeta.min;
        const max = +property.valueMeta.max;
        const options = [];
        for (let i = min; i <= max; i++) {
            options.push(String(i));
        }
        return options;
    }

    getOnOffTimeOptions(property) {
        if (property.valueMeta && property.valueMeta.availableValues && property.valueMeta.availableValues.length > 0) {
            return property.valueMeta.availableValues;
        }
        const min = +property.valueMeta.min * 10;
        const max = +property.valueMeta.max * 10;
        const options = [];
        for (let i = min; i <= max; i++) {
            options.push(String(i / 10));
        }
        return options;
    }

    getHoldUpTime(property) {
        if (property.valueMeta && property.valueMeta.availableValues && property.valueMeta.availableValues.length > 0) {
            return property.valueMeta.availableValues;
        }
        const min = +property.valueMeta.min;
        const max = +property.valueMeta.max;
        const options = [];
        for (let i = min; i <= max; i++) {
            options.push(String(i));
        }
        return options;
    }

    renderPresetRows() {
        const {properties} = this.props;
        const {numberOfPresets, activePresetIndex} = this.state;
        const rows = [];
        const activePresetIndexProp = properties[MLS_MULTI_LUM.activePresetIndex].valueMeta;

        return activePresetIndexProp.availableValues.map((value, index) => {
            const propertyKey = MLS_MULTI_LUM[`presetCurrent${value}`];
            const property = properties[propertyKey];
            const isDisabled = value > numberOfPresets;
            const isChecked = String(activePresetIndex) === value;

            if (!property) {
                return;
            }

            return (
                <Row key={index} style={{margin: '0.5rem auto 0', flexWrap: 'nowrap', alignItems: 'center'}}>
                    <Col sm={4} style={{paddingLeft: 0, display: 'flex', alignItems: 'center'}}>
                        {`Preset Current ${value}`}
                    </Col>
                    <Col sm={5} style={{padding: 0}}>
                        <PropertyPicker
                            property={property}
                            min={200}
                            max={1000}
                            step={1}
                            measureUnit="mA"
                            disabled={isDisabled}
                            margin="0"
                            titleSize={0}
                            inputSize={7}
                            unitSize={5}
                            handleChange={this.handleChange}
                        />
                    </Col>
                    <Col sm={3} style={{padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Radio
                            disabled={isDisabled}
                            style={{padding: 0, opacity: isDisabled ? 0.38 : 1}}
                            checked={isChecked && !isDisabled}
                            name={MLS_MULTI_LUM.activePresetIndex}
                            onClick={() => {
                                if (!isDisabled) this.handleRadioChange(value);
                            }}
                            onChange={() => {
                                if (!isDisabled) this.handleRadioChange(value);
                            }}
                        />
                    </Col>
                </Row>
            );
        });
    }

    render() {
        const {properties} = this.props;

        const numberOfPresets = properties[MLS_MULTI_LUM.numberOfPresets];
        const onOffTime = properties[MLS_MULTI_LUM.onOffTime];
        const onOffCycles = properties[MLS_MULTI_LUM.onOffCycles];
        const holdUpTime = properties[MLS_MULTI_LUM.holdUpTime];

        const presetsClassName = this.getClassName([
            properties[MLS_MULTI_LUM.presetCurrent1],
            properties[MLS_MULTI_LUM.presetCurrent2],
            properties[MLS_MULTI_LUM.presetCurrent3],
            properties[MLS_MULTI_LUM.presetCurrent4],
            properties[MLS_MULTI_LUM.presetCurrent5],
            properties[MLS_MULTI_LUM.presetCurrent6],
            properties[MLS_MULTI_LUM.presetCurrent7],
            properties[MLS_MULTI_LUM.presetCurrent8],
            properties[MLS_MULTI_LUM.activePresetIndex],
        ].filter(Boolean));

        const timingClassName = this.getClassName([onOffTime, onOffCycles, holdUpTime].filter(Boolean));

        return (
            <Row>
                <Col sm={3}>
                    {/* Card 1 — Number of Presets */}
                    <Card className="card-feature-component" style={{width: '100%'}}>
                        <div className="card-header-feature">Number of Presets</div>
                        <Card.Body className="card-body-feature" style={{paddingTop: '0.75rem'}}>
                            <PropertyDropdown
                                property={numberOfPresets}
                                title={numberOfPresets.info.displayName}
                                properties={this.getNumberOfPresetsOptions(numberOfPresets)}
                                handleChange={this.handleChange}
                                measureUnit=""
                                titleSize={6}
                                dropdownSize={6}
                            />
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={5}>
                    {/* Card 2 — Preset Currents + Active Preset Index radios */}
                    <Card className={presetsClassName} style={{width: '100%'}}>
                        <div className="card-header-feature">
                            <Row style={{margin: 0, flexWrap: 'nowrap'}}>
                                <Col sm={4} style={{paddingLeft: 0}}>Preset</Col>
                                <Col sm={5} style={{padding: 0}}>Current (mA)</Col>
                                <Col sm={3} style={{padding: 0, textAlign: 'center'}}>Active</Col>
                            </Row>
                        </div>
                        <Card.Body className="card-body-feature" style={{paddingTop: '0.5rem'}}>
                            {this.renderPresetRows()}
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={4}>
                    {/* Card 3 — Timing */}
                    <Card className={timingClassName} style={{width: '100%'}}>
                        <div className="card-header-feature">Timing</div>
                        <Card.Body className="card-body-feature" style={{paddingTop: '0.75rem'}}>
                            <PropertyDropdown
                                property={onOffTime}
                                title={onOffTime.info.displayName}
                                properties={this.getOnOffTimeOptions(onOffTime)}
                                measureUnit="s"
                                handleChange={this.handleChange}
                                titleSize={6}
                                dropdownSize={4}
                                measureUnitSize={2}
                            />
                            <PropertyDropdown
                                property={holdUpTime}
                                title={holdUpTime.info.displayName}
                                properties={this.getHoldUpTime(holdUpTime)}
                                measureUnit="s"
                                handleChange={this.handleChange}
                                titleSize={6}
                                dropdownSize={4}
                                measureUnitSize={2}
                            />
                            <PropertyPicker
                                property={onOffCycles}
                                title={onOffCycles.info.displayName}
                                min={3}
                                max={10}
                                step={1}
                                handleChange={this.handleChange}
                                titleSize={6}
                                inputSize={4}
                                unitSize={2}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => ({
    issues: state.project.issueByProperty,
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MultiLumSettings);
